'helper'.trashAll('Inventory')
'helper'.trashAll('Cluster')
'helper'.trashAll('Clump')
'helper'.trashAll('Location')
'helper'.trashAll('Adjustment')
'helper'.trashAll('PO')
'helper'.trashAll('SO')
'helper'.trashAll('Supplier')
'helper'.trashAll('Attachment')
'helper'.simulateBrowserRefresh()
'stocktend_search'.click()
  'Search'.shouldBeCurrentPage()
  'mainTable'.shouldBeEmpty()
  'searcher'.shouldEqual('')
  'searcher'.enter('bom')
  'mainTable'.shouldBeEmpty()
  'Back'.click()
'stocktend_suppliers'.click()
  'Add'.click()
    'Name'.enter('Bombast Corporation')
    'Phone'.enter('0433318462')
    'OK'.click()
  'Back'.click()
'stocktend_search'.click()
  'searcher'.shouldEqual('bom')
  'mainTable'.shouldHaveCount(1)
  'mainTable.0.Bombast Corporation'.click()
    'Edit Supplier'.shouldBeCurrentPage()
    'Name'.shouldEqual('Bombast Corporation')
    'OK'.click()
  'mainTable'.shouldHaveCount(1)
  'searcher'.enter('0444')
  'mainTable'.shouldBeEmpty()
  'searcher'.enter('0433')
  'mainTable'.shouldHaveCount(1)
  'mainTable.0.Field Name'.shouldEqual('phone')
  'mainTable.0.Value'.shouldContain('318462')
  'Back'.click()
